import { product, productCategory } from '@/common/service/ApiList';
import { updateToast, insertToast, removeToast, customToast } from '@/common/utils/ToastServiceResult';
import { assist } from '@/common/utils/ParameterAssistant';

import ServiceExec from '@/common/utils/ServiceExec';
import { asFormData } from '@/common/utils/ServiceSupport';
import { cloneDeep } from 'lodash';
import store from '@/store';

const { getList, detail, save, remove, setSoldOut, setForSale, hide, show, saveBulk, save_order } = product;

const actions = {
  FETCH_LIST: async ({ commit, state }, page) => {
    const { condition } = state;
    commit('setCondition', assist(condition, page));

    const { status, data } = await ServiceExec.get(getList, condition);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  FETCH_DETAIL: async ({ commit, state, rootGetters }, productNo) => {
    const { store } = rootGetters['admin/loginData'];
    const storeNos = store?.map((ele) => ele.storeNo) ?? [];
    const { status, data } = await ServiceExec.get(detail(productNo), { storeNos });
    if (status === 200) commit('setDetail', data);
    if (status !== 200) {
      customToast(status, data, '');
      setTimeout(() => {
        location.href = '/';
      }, 2000);
    }

    commit('setDetail', data);
  },

  SAVE_DETAIL: async ({ commit, state, getters }, form) => {
    const { status, data } = await ServiceExec.post(save, asFormData(form));

    if (data) {
      const categories = store.getters['common/getProductCategories'];
      const productListState = getters['getList'];

      productListState.forEach((e, idx) => {
        if (e.productNo === form.productNo) {
          productListState[idx].nameKr = form.nameKr;
          productListState[idx].nameVn = form.nameVn;
          productListState[idx].price = form.price;
          productListState[idx].discountRate = form.discountRate;
          productListState[idx].isOrderable = form.isOrderable;
          productListState[idx].isShow = form.isShow;
          productListState[idx].isManageStock = form.isManageStock;
          productListState[idx].stock = form?.stock;
          productListState[idx].barcode = form?.barcode;
          productListState[idx].category = categories.find((ele) => ele.productCategoryNo === form.productCategoryNo);
        }
      });
    }

    if (form.productNo && updateToast(status, data)) return true;
    else if (!form.productNo && insertToast(status, data)) return true;
    else return false;
  },
  REMOVE_DETAIL: async ({ commit, state }, { productNo }) => {
    const { status, data } = await ServiceExec.delete(remove(productNo));
    if (status === ServiceExec.status.OK && removeToast(status, data)) return true;
    return false;
  },
  FETCH_FOR_XLSX: async ({ state }) => {
    const { condition } = state;
    const _condition = cloneDeep(condition);
    _condition.limit = -1;
    _condition.page = 1;

    const { status, data } = await ServiceExec.get(getList, _condition);
    if (status !== 200) return [];
    const { list } = data;

    return list;
  },
  SET_SOLD_OUT: async ({ state }, targets = []) => {
    const { status, data } = await ServiceExec.patch(setSoldOut, targets);
    updateToast(status, data);
  },
  SET_FOR_SALE: async ({ state }, targets = []) => {
    const { status, data } = await ServiceExec.patch(setForSale, targets);
    updateToast(status, data);
  },
  SET_HIDE: async ({ state }, targets = []) => {
    const { status, data } = await ServiceExec.patch(hide, targets);
    updateToast(status, data);
  },
  SET_SHOW: async ({ state }, targets = []) => {
    const { status, data } = await ServiceExec.patch(show, targets);
    updateToast(status, data);
  },
  SAVE_BULK: async ({ state }, bulk) => {
    const { status, data } = await ServiceExec.postWithProgressBar(saveBulk, bulk);
    insertToast(status, data);
  },

  FETCH_PRODUCT_BY_CATEGORY: async ({ commit, state }, payload) => {
    const { status, data } = await ServiceExec.get(getList, payload);
    if (status !== 200) return;

    return data.list;
  },

  SAVE_ORDER: async ({ state, commit }, orderList) => {
    const { status, data } = await ServiceExec.patch(save_order, orderList);
    if (status !== ServiceExec.status.OK) return;

    updateToast(status, data);
  }
};
export default actions;
